import { Injectable } from '@angular/core';
import { Logger } from '../logger.service';
import { Http } from '@angular/http';
@Injectable()
export class OauthHelper {
	constructor(private logger: Logger, private http: Http) {}
	public handleOauthResponse() {
		let response: string = this.removeHash(window.location.hash);
		let responseMap: {} = this.buildResponseMap(response);
		console.log(responseMap)
		console.log(response)

		// in some cases Firefox in Version 67.0.4 did not persist our oauthState in localStorage, here we use the sessionStorage as fallback
		let state = localStorage.getItem("oauthState");
		if (state == null) {
			console.log('used sessionStorage as fallback')
			state = sessionStorage.getItem("oauthState");
		}

		// clean up state
		localStorage.setItem("oauthState", state);
		sessionStorage.removeItem("oauthState");

		if (responseMap == null)
			return ;
		if (responseMap["state"] === localStorage.getItem("oauthState")) {
			this.storeAccessToken(responseMap["access_token"]);
			this.clearImpersonationState();
		} else {
			this.logger.error("possible CSRF-Attack");
			throw new Error("possible csrf");
		}
		window.location.hash = "";

	}

	private removeHash(response: string): string {
		if (response == null) {
			return "";
		}
		return response.substr(1);
	}

	private buildResponseMap(response: string) {
		if (response.indexOf("&") === -1 || response.indexOf("=") === -1) {
			return null;
		}
		let responseMap: {} = {}
		let entries: string[] = response.split("&");
		for (let entry of entries){
			let keyValue: string[] = entry.split("=")
			responseMap[keyValue[0]] = keyValue[1];
		}
		return responseMap;
	}

	public saveStateNumber(state) {
		localStorage.setItem("oauthState", state);
		sessionStorage.setItem("oauthState", state);
	}

	public storeAccessToken(accessToken: string) {
		console.debug("AccessToken: " + accessToken);
		localStorage.setItem("id_token", accessToken);
	}

	public getAccessToken(): string {
		return localStorage.getItem("id_token");
	}

	public deleteAccessToken() {
		localStorage.removeItem("id_token");
	}

	public logout() {
		this.deleteAccessToken();
		setTimeout(() => window.location.replace(ZUUL_BACKEND + "/auth/logout?redirectUrl=" + window.location.href), 100);
	}

	public clearImpersonationState() {
		localStorage.removeItem("impersonated");
		localStorage.removeItem("stored_tokens");
	}

}





// WEBPACK FOOTER //
// ./src/app/services/webservice/oauth-helper.service.ts